import React from "react";

export function useGetFavorites<T>(key: string, defaultValue: T) {
  const [state, setState] = React.useState<T>((value = defaultValue) => {
    try {
      return JSON.parse(
        window.localStorage.getItem(key) || JSON.stringify(value)
      );
    } catch (e) {
      return value;
    }
  });

  React.useEffect(() => {
    window.localStorage.setItem(key, JSON.stringify(state));
  }, [state]);
  return [state, setState] as [T, React.Dispatch<React.SetStateAction<T>>];
}
